import { render, staticRenderFns } from "./BoardBadgesSVG.vue?vue&type=template&id=086f4f9b&scoped=true&"
import script from "./BoardBadgesSVG.vue?vue&type=script&lang=js&"
export * from "./BoardBadgesSVG.vue?vue&type=script&lang=js&"
import style0 from "./BoardBadgesSVG.vue?vue&type=style&index=0&id=086f4f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f4f9b",
  null
  
)

export default component.exports